let $ = jQuery.noConflict(),
	devMode,
	mobileCheck = false,
	pageTransition,
	pageTransitionEnabled = false,
	resizeCallbacks = [],
	clickOrTouch,
	mobileResizeCallbacks = [],
	mapHelper,
	smoother;

$(function () {
	new StarterKitMcube();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
		new SmoothScroll();
	}

	new Lottie();
	new AlertPopup();
	new BannerHome();
	new BlockContact();
	new BlockFlipCards();
	new BlockTabs();
	new BlockTextImage();
	new Buttons();
	new Clouds();
	new FixSafariKeyframesResize();
	new NavMain();
	new GoogleMapListing();
	new GoogleMapIndividual();
	new GoogleMapSingleNursery();
	new Select();

	new Home();
	new ArchiveNursery();


});
